/**
 * 모듈 셀 표시에 영향 주는 필드만 모은 시그니처 — 탭뷰 update의 rebuild diff 게이트용(Phaser 비의존 순수).
 *
 * 전투/합성/융합 탭은 게임 진행 중 mutation flush(공·벽돌 파괴)·250ms 타이머마다 refresh되는데,
 * 미배치 모듈 인벤토리가 그대로면 셀 rebuild(relayoutContent + Text.setText 전체)가 불필요하다.
 * update가 직전 적용한 시그니처와 비교해 동일하면 rebuild를 건너뛴다(setText 텍스처 재생성 렉 방지).
 *
 * 비교 대상: instanceId(목록 구성) + level/rarity/footprintId/shapeId(라벨·색·심볼) + placed(배치 dim, 팔레트).
 * 선택 상태(selectedIds)는 별도 refreshSelectionVisual 경로라 시그니처에 미포함.
 */
export interface SignatureRow {
  readonly instanceId: string;
  readonly level: number;
  readonly rarity: string;
  readonly footprintId: string;
  readonly shapeId: string;
  /** 그리드 배치 여부(팔레트 dim) — 합성/융합 행엔 없음(undefined→0). */
  readonly placed?: boolean;
}

export function moduleRowsSignature(rows: readonly SignatureRow[]): string {
  let s = "";
  for (const r of rows) {
    s += `${r.instanceId}:${r.level}:${r.rarity}:${r.footprintId}:${r.shapeId}:${r.placed ? 1 : 0}|`;
  }
  return s;
}
